import { AppBar, Toolbar, useTheme } from "@mui/material";
import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
} from "@websential/cosmic-v20";

import { FC } from "react";

export interface IGlobalVariablesSetupToolbar {
	onDeleteClicked: () => void;
	isSubmitting: boolean;
	id?: any;
}

export const GlobalVariablesSetupToolbar: FC<IGlobalVariablesSetupToolbar> = ({
	onDeleteClicked,
	isSubmitting = false,
	id,
}) => {
	const theme = useTheme();
	return (
		<AppBar
			position="sticky"
			color="default"
			elevation={1}
			sx={{
				backgroundColor: "#fff",
				// marginTop: theme.spacing(3),
				boxShadow: "none",
				alignItems: "center",
				bottom: 0,
			}}
		>
			<Toolbar>
				<>
					<EnhancedButtonPrimeReact
						label="Submit"
						loading={isSubmitting}
						type="submit"
						raised
						severity={EnhancedButtonPrimeReactSeverity.Success}
					/>
					<EnhancedButtonPrimeReact
						label="Delete"
						raised
						onClickHandler={onDeleteClicked}
						style={{ marginLeft: "1rem" }}
						severity={EnhancedButtonPrimeReactSeverity.Danger}
						disabled={!id ? true : false}
					/>
				</>
			</Toolbar>
		</AppBar>
	);
};
